import { useEffect } from "react";
import { NavLink } from "react-router-dom";
export default function NotLogtedUserNavBar() {
  useEffect(() => {
    const toggleOpen = document.querySelector(".forToggleOpen");
    const toggleClose = document.querySelector(".forToggleClose");
    const header = document.querySelector(".header");
    const navbarLink = document.querySelectorAll(".navbarLink");
    toggleOpen.addEventListener("click", () => {
      header.classList.add("active");
    });
    toggleClose.addEventListener("click", () => {
      header.classList.remove("active");
    });
    navbarLink.forEach((element) => {
      element.addEventListener("click", () => {
        header.classList.remove("active");
      });
    });
    // console.log(navbarLink[0].class)
    return () => {
      toggleOpen.removeEventListener("click", () => {});
      toggleClose.removeEventListener("click", () => {});
    };
  }, []);
  return (
    <>
      <nav className="navbar navbar">
        <ul className="navbarUl">
          <li>
            <NavLink
              to="/home"
              className={({ isActive }) => (isActive ? "navLogInfo" : "")}
            >
              <span className="navbarLink home">home</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className={({ isActive }) => (isActive ? "navLogInfo" : "")}
            >
              <span className="navbarLink about">about</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/service"
              className={({ isActive }) => (isActive ? "navLogInfo" : "")}
            >
              <span className="navbarLink service">service</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) => (isActive ? "navLogInfo" : "")}
            >
              {/* navInfo this a class */}
              <span className="navbarLink contactUs">contact us</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/login"
              className={({ isActive }) => (isActive ? "navLogInfo" : "")}
            >
              <span className=" navbarLink loginLink">login</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/reg"
              className={({ isActive }) => (isActive ? "navSignInfo" : "")}
            >
              <span className="navbarLink signLink">sign up</span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </>
  );
}
